import * as React from 'react'
import { withStatus } from '../modules/status'
import './info.css'


@withStatus
export default class extends React.Component<any>{
    
    private icon:HTMLElement;


    onClick(){
        this.icon.blur();
        
        const message = this.props.message
        const title = this.props.title
        this.props.actions.status.showMessage(title, message, false);
    }


    render(){
        return <button className="icon-button pulse" ref={ ref => this.icon = ref } onClick={ this.onClick.bind(this) }><i className="fa fa-exclamation-circle exclaim-icon"></i></button>
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/info.tsx